import type { TFunction } from 'i18next';

/**
 * Conversation/source type labels used in filters and usage.
 * Single source of truth for display names (excluding "All conversations").
 * Any namespace's t will do: the keys live in common, which every page loads.
 */
export const conversationSourceLabels = (t: TFunction): Record<string, string> => ({
  'plerion-platform': t('plerionPlatform', { ns: 'common' }),
  email: t('email', { ns: 'common' }),
  task: t('task', { ns: 'common' }),
  slack: t('slack', { ns: 'common' }),
  mcp: t('mcp', { ns: 'common' }),
  spotlight: t('spotlight', { ns: 'common' }),
  'product-update': t('productUpdate', { ns: 'common' }),
});

export function getConversationSourceLabel(t: TFunction, raw: string): string {
  const labels = conversationSourceLabels(t);
  const key = raw.toLowerCase().replace(/\s+/g, '');
  return labels[key] ?? labels[raw] ?? raw;
}
